import React, { useEffect, useState } from "react";
import Apiconnect from "../services/Apiconnect"; // adjust path if needed

const MeetingList = () => {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch meeting list
  const fetchMeetings = async () => {
    try {
      const response = await Apiconnect.postData("meeting_list", {}); 
console.log(response)
      if (response?.data?.status === "1") {
        setMeetings(response.data.data || []);
      } else {
        setMeetings([]);
      }
    } catch (error) {
      console.error("Error fetching meetings:", error);
      setMeetings([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMeetings();
  }, []);

  return (
    <div className="container-fluid">
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <h2 className="mb-4 fw-bold">Meeting List</h2>

          {loading ? (
            <p>Loading...</p>
          ) : meetings.length === 0 ? (
            <p className="text-muted">No meetings available.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Lead Mail</th>
                    <th>Customer ID</th>
                    <th>Lead ID</th>
                   
                    <th>Date & Time</th>
                  </tr>
                </thead>
                <tbody>
                  {meetings.map((meeting, index) => {
                    
                    return (
                      <tr key={meeting.id}>
                        <td>{index + 1}</td>
                        <td>{meeting.lead_mail || "N/A"}</td>
                        <td>{meeting.cust_id}</td>
                        <td>{meeting.cust_lead_id}</td>
                       
                        <td>{meeting.created_on}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MeetingList;
